// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KeywordCloud_keyword-cloud-container__lWlSL {
  position: relative;
}
.KeywordCloud_keyword-cloud-container__lWlSL .KeywordCloud_loading__u7Zp6 {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--background-color-2);
  z-index: 1;
}`, "",{"version":3,"sources":["webpack://./src/Explore/Components/KeywordCloud/KeywordCloud.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;AACE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,2CAAA;EACA,UAAA;AACJ","sourcesContent":[".keyword-cloud-container {\n  position: relative;\n\n  .loading {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: var(--background-color-2);\n    z-index: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"keyword-cloud-container": `KeywordCloud_keyword-cloud-container__lWlSL`,
	"loading": `KeywordCloud_loading__u7Zp6`
};
export default ___CSS_LOADER_EXPORT___;
